/** @format — Shipments grid when sorting by shipment */

import { cn } from "@/lib/utils";
import {
  listingRouteLabel,
  listingVehicleLabel,
} from "../utils/documentFormatters";
import type { ListingWithDocuments } from "../types";

function ShipmentCard({
  listing,
  active,
  onClick,
}: {
  listing: ListingWithDocuments;
  active?: boolean;
  onClick: () => void;
}) {
  const vehicle = listingVehicleLabel(listing.vehicles);
  const route = listingRouteLabel(listing.origin, listing.destination);
  const label = listing.shipmentId || listing.listingId.slice(0, 8).toUpperCase();

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex w-full items-center gap-3 rounded-lg border p-3 text-left transition-colors",
        active
          ? "border-neutral-200 bg-neutral-100"
          : "border-neutral-200 bg-white hover:bg-neutral-50",
      )}
    >
      <img src="/closed-document.svg" alt="" className="h-7 w-[31px] shrink-0 object-contain" />
      <div className="min-w-0 flex-1">
        <p className="text-[10px] font-semibold uppercase text-neutral-500">{label}</p>
        <p className="mt-1 truncate text-sm font-medium text-[#0a0a0a]">{vehicle}</p>
        <p className="mt-1 truncate text-sm font-medium text-neutral-500">{route}</p>
      </div>
      <p className="shrink-0 text-sm font-medium text-neutral-500">
        {listing.totalDocuments} docs
      </p>
    </button>
  );
}

export default function DocumentsShipmentGrid({
  listings,
  onSelect,
  selectedId,
}: {
  listings: ListingWithDocuments[];
  onSelect: (listing: ListingWithDocuments) => void;
  selectedId?: string;
}) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {listings.map((listing) => (
        <ShipmentCard
          key={listing.listingId}
          listing={listing}
          active={selectedId === listing.listingId}
          onClick={() => onSelect(listing)}
        />
      ))}
    </div>
  );
}
